var glerups = glerups || {}



//glerups.translateShoeSize = function(size) {  }


setTimeout(() => {
    var validator = document.querySelectorAll('.SizeSwatch__Label p') && document.querySelectorAll('.SizeSwatch__Label p').length ;
    if(validator) { 

        document.querySelectorAll('.SizeSwatch__Label p').forEach(x => { 
            
            let shoeSize = x.innerHTML;
            let shoeSizeLabel = x.parentNode.parentNode;
            
            
            
            //let p = document.createElement("p");
            
            let convertToUs = x.innerText; 
            let inUSSize = setUsSizeDropdown(convertToUs);
            
            x.innerHTML = x.innerHTML + ' ' + inUSSize;;
            //x.parentNode.parentNode.append(p)
            
            //x.parentNode.remove();
            
        });
    }



  

}, "1200")

setTimeout(() => {


 


  const shippingHeader = document.querySelector('.section--shipping-address .section__header');
  let shippingDKElement = document.createElement("p");
  shippingDKElement.style.backgroundColor = "#eee";
  shippingDKElement.style.padding = "0.50rem";
  shippingDKElement.style.marginTop = "5px";
  let shippingDKText = document.createTextNode("Note: Delivery from Denmark - expect delivery time approx. 5-10 working days to UK ");
  if (shippingHeader !== null) {
  shippingDKElement.appendChild(shippingDKText);
  shippingHeader.appendChild(shippingDKElement);
  }
  
        
    var checkoutValidator = document.querySelectorAll('.total-line-table__tbody') && document.querySelectorAll('.total-line-table__tbody').length ;
    if(checkoutValidator) { 
    var taxLineElementTr = document.createElement("tr");
    var taxLineElementTd = document.createElement("td");
    taxLineElementTr.appendChild(taxLineElementTd);
    taxLineElementTd.innerHTML = 'Note: Duty and import taxes are included';
    taxLineElementTd.style.textAlign = "left";
    taxLineElementTd.style.fontStyle = "italic";
    taxLineElementTd.style.paddingTop = "10px";
    document.querySelector('.total-line-table__tbody').appendChild(taxLineElementTr);


    
    document.querySelectorAll('.product__description__variant').forEach(x => { 
    let sizeToConvert = x.innerHTML;
    
    let usSizesConverted = 
    setUsSizeDropdown(sizeToConvert);
    
    x.innerHTML = x.innerHTML + ' ' + usSizesConverted;
    })
}
  }, "1200")


function setUsSizeDropdown (mysize) {
    let sizeSelected = String(mysize);
  switch (sizeSelected) {
    case "00":
      usSize = 'None';
      break;
    case "16":
      usSize = "EU (Baby 0.5 UK)";
      break;
    case "17":
      usSize = "EU (Baby 1 UK)";
      break;
    case "18":
      usSize = "EU (Baby 1.5 UK)";
      break;
    case "19":
      usSize = "EU (Baby 2.5 UK)";
      break;
    case "20":
      usSize = "EU (Kids 3.5 UK)";
      break;
    case "21":
      usSize = "EU (Kids 4 UK)";
      break;
    case "22":
      usSize = "EU (Kids 4 UK)";
      break;
    case "23":
      usSize = "EU (Kids 5 UK)";
      break;
    case "24":
      usSize = "EU (Kids 6 UK)";
      break;
    case "25":
      usSize = "EU (Kids 7 UK)";
      break;
    case "26":
      usSize = "EU (Kids 8 UK)";
      break;
     case "27":
      usSize = "EU (Kids 9 UK)";
      break;
     case "28":
      usSize = "EU (Kids 10 UK)";
      break;
     case "29":
      usSize = "EU (Kids 11 UK)";
      break;
     case "30":
      usSize = "EU (Kids 11.5 UK)";
      break;
    case "31":
      usSize = "EU (Kids 12 UK)";
      break;
     case "32":
      usSize = "EU (Kids 12 UK)";
      break;
    case "33":
      usSize = "EU (Kids 1 UK)";
      break;
    case "34":
      usSize = "EU (Kids 2 UK)";
      break;
    case "35":
      usSize = "EU (2.5 UK)";
      break;
    case "36":
      usSize = "EU (3.5 UK)";
      break;   
    case "37":
      usSize = "EU (4 UK)";
      break;
    case "38":
      usSize = "EU (5 UK)";
      break;
    case "39":
      usSize = "EU (6 UK)";
      break;
      case "40":
      usSize = "EU (6.5 UK)";
      break;
      case "41":
      usSize = "EU (7.5 UK)";
      break;
      case "42":
      usSize = "EU (8 UK)";
      break;
     case "43":
      usSize = "EU (9 UK)";
      break;
     case "44":
      usSize = "EU (9.5 UK)";
      break;
     case "45":
      usSize = "EU (10.5 UK)";
      break;
     case "46":
      usSize = "EU (11 UK)";
      break;
     case "47":
      usSize = "EU (12 UK)";
      break;
     case "48":
      usSize = "EU (13 UK)";
      break;
      case "49":
      usSize = "EU (14 UK)";
      break;
     case "50":
      usSize = "EU (14.5 UK)";
      break;
     case "51":
      usSize = "EU (15 UK)";
      break;
     case "52":
      usSize = "EU (16.5 UK)";
      break;
      case "19-21":
      usSize = "EU (Kids 2.5-4 UK)";
      break;
     case "22-24":
      usSize = "EU (Kids 4-6 UK)";
      break;
     case "25-27":
      usSize = "EU (Kids 7-9 UK)";
      break;
     case "28-30":
      usSize = "EU (Kids 10-11.5 UK)";
      break;
     case "31-33":
      usSize = "EU (Kids 12, 12, 1 UK)";
      break;
     case "34-36":
      usSize = "EU (2-3.5 UK)";
      break;
     case "37-39":
      usSize = "EU (4-6 UK)";
      break;
     case "40-42":
      usSize = "EU (6.5-8 UK)";
      break;
     case "43-45":
      usSize = "EU (9-10.5 UK)";
      break;
     case "46-48":
      usSize = "EU (11-13 UK)";
      break;
    default:
      usSize = "";
      break;
  }
    return usSize; 
  }


/*
  SetSizeDropDownUS ()

let sizeCollection = document.getElementsByClassName('Popover__Value')

for (let i = 0; i < sizeCollection.length; i++) {
  let sizeToString = String(sizeCollection[i].textContent);
  let sizeFunction = setUsSizeDropdown(sizeToString)
  
 sizeCollection[i].textContent = sizeCollection[i].textContent + ' ' + sizeFunction;

sizeCollection[i].addEventListener('click', function() {
setTimeout(function(){  

let selectedProductSize = document.getElementsByClassName('ProductForm__SelectedValue')[0].innerText;

SetSizeDropDownUS ()
}, 500);






});


  
}
*/

  


// == Set dropdown US size
/*
function SetSizeDropDownUS () {
let selectedSizeValue = document.getElementsByClassName('ProductForm__SelectedValue')[0].innerText;


let selectedSizeFieldInUSSize = setUsSizeDropdown(selectedSizeValue)
document.getElementsByClassName('ProductForm__SelectedValue')[0].innerText = selectedSizeValue + ' ' + selectedSizeFieldInUSSize ;








}
*/


 






/*
let test = document.getElementsByClassName('ProductForm__Option ');

for (let i = 0; i < test .length; i++) {

test[0].addEventListener('change', function() {

});
*/